import Immutable from 'immutable';
import get from 'lodash/get';

import * as constants from './actions';

const initialState = {
  route: '',
  isRTL: false,
  online: true,
  isBlackListed: false,
};

export default (state = Immutable.Map(initialState), action) => {
  switch (action.type) {
    case constants.APP_ROUTE_TO_KUSTY:
      return state.set('route', 'kusty');
    case constants.APP_ROUTE_TO_NONE:
      return state.set('route', 'none');
    case constants.APP_ROUTE_TO_APP:
      return state.set('route', 'app');
    case constants.APP_RTL:
      return state.set('isRTL', true);
    case constants.APP_ONLINE:
      return state.set('online', true);
    case constants.APP_OFFLINE:
      return state.set('online', false);
    case constants.APP_BLACKLIST: {
      const value = get(action, 'payload.value');
      return state.set('isBlackListed', value);
    }
    default: {
      return state;
    }
  }
};
